import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { jsx as _jsx } from "react/jsx-runtime";
import { useMemo, createContext, useContext } from 'react';
import { DeviceProvider as SeagullDeviceProvider } from 'seagull';
const RootDeviceContext = /*#__PURE__*/ createContext({
    isMobileDevice: false
});
export function RootDeviceProvider(param) {
    let { children, isMobileDevice } = param;
    const value = useMemo(()=>({
            isMobileDevice
        }), [
        isMobileDevice
    ]);
    return /*#__PURE__*/ _jsx(RootDeviceContext.Provider, {
        value: value,
        children: children
    });
}
export const useRootDevice = ()=>useContext(RootDeviceContext);
export function withDeviceProvider(Component) {
    return function WithDeviceProvider(props) {
        const { isMobileDevice } = useRootDevice();
        const value = useMemo(()=>({
                isMobileDevice
            }), [
            isMobileDevice
        ]);
        return /*#__PURE__*/ _jsx(SeagullDeviceProvider, {
            value: value,
            children: /*#__PURE__*/ _jsx(Component, _object_spread({}, props))
        });
    };
}
